import { SingleSelectInput } from "components";
import { observer } from "mobx-react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import React, { FC, useCallback } from "react";
import { TReapitNegotiatorOptionData } from "types/reapit.type";
import { TSelectOption, TSelectValue } from "types/select-input.type";
import { ReapitNegotiatorIntegrationSyncSelectOption } from "components/select-input/custom-options/ReapitNegotiatorIntegrationSyncSelectOption";
import { List } from "react-virtualized";

interface IProps {
  accountStore: UserAccountStore;
  value: string | null;
  onChange: (reapitId: TSelectValue<string>) => void;
  disabled?: boolean;
}

export const ReapitNegotiatorSyncSelect: FC<IProps> = observer(
  ({ accountStore, value, onChange, disabled }) => {
    const reapitNegotiatorOptions =
      accountStore.accountIntegrationsStore.accountIntegrationReapitStore
        .accountIntegrationReapitNegotiatorsStore.reapitNegotiatorsOptions;

    const handleChange = useCallback(
      (reapitId: TSelectValue<string>) => {
        onChange(reapitId);
      },
      [onChange]
    );

    const optionsFilter = useCallback(
      (
        options: TSelectOption<string, TReapitNegotiatorOptionData>[],
        searchTerm: string
      ) => {
        return options.filter(option =>
          option.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
      },
      []
    );

    return (
      <SingleSelectInput
        disabled={disabled}
        value={value}
        clearable={true}
        options={reapitNegotiatorOptions}
        onChange={handleChange}
        filterFn={optionsFilter}
        optionsRenderer={optionProps => (
          <List
            rowHeight={55}
            height={300}
            rowCount={optionProps.length}
            width={290}
            rowRenderer={({ key, index, style }) => (
              <div style={style} key={key}>
                {optionProps[index] && (
                  <ReapitNegotiatorIntegrationSyncSelectOption
                    optionProps={optionProps[index]}
                    disableOnSync
                  />
                )}
              </div>
            )}
          />
        )}
      />
    );
  }
);
